import React from 'react';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import {
  ToggleHeader,
  TextTitle
} from '../../../certificates-constancies/type1/register/components';
import { BackButton } from '../../../../components';
import { Block } from '../../../../../../components';
import Step from '../../UpdatePhoto/Register/components/Step';
import ResumeDetail from '@/presentation/modules/procedures/components/Resume';
import CardProgress from '@/presentation/reusables/CardProgress';
import {
  documentSuccessImage,
  documentSuccessDskImage,
  documentFailedImage,
  documentFailedDskImage,
  requestInProgressImage,
  requestInProgressDskImage
} from '@/presentation/modules/procedures/components/Images';

interface RectificationProgressViewProps {
  handlerBackButton: any;
  procedure: any;
  request: any;
  isComplete: boolean;
}

const RectificationProgressView = ({
  handlerBackButton,
  procedure,
  request,
  isComplete
}: RectificationProgressViewProps) => {
  let images;
  let title;
  let subtitle;
  let comentary;
  switch (request?.status?.status) {
    case 'PROCEDE':
      images = [documentSuccessImage, documentSuccessDskImage];
      title = 'Tu solicitud procede';
      subtitle = 'Tu nota ya ha sido actualizada.';
      break;
    case 'NO_PROCEDE':
      images = [documentFailedImage, documentFailedDskImage];
      title = 'Tu solicitud no procede';
      subtitle = 'Tu nota no ha sido actualizada.';
      comentary = procedure?.detail?.rectificationOfGradesDetail?.commentary;
      break;
    default:
      images = [requestInProgressImage, requestInProgressDskImage];
      title = 'Tu solicitud está pendiente';
      subtitle =
        'Te notificaremos por correo cuando tu solicitud esté finalizada.';
      break;
  }
  return (
    <ContainerProcedure data-testid="cmp-rectificationProgressView">
      <SubContainer style={{ marginBottom: 24 }}>
        <BackButton onClick={handlerBackButton} />
      </SubContainer>
      <SubContainer>
        <ToggleHeader
          status={request.status}
          name={procedure.name}
          amount={procedure.amount}
          duration={procedure.duration}
          childContent={<ProcedureInfoComponent inRegister />}
        />
        <TextTitle title="Progreso" />
        <Block customized padding="28px 0px 45px 8px">
          <Step name="Registrar solicitud" order={1} isComplete>
            <ResumeDetail
              title="Detalle de solicitud:"
              data={procedure?.detail?.rectificationOfGradesDetail}
              labels={['Curso', 'Evaluación', 'Nota a rectificar', 'Motivo']}
              fields={['course', 'evaluation', 'currentGrade', 'reasonName']}
              showBullets
            />
          </Step>
          <Step
            name="Revisar estado de solicitud"
            order={2}
            isComplete={isComplete}
            isLast
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <ResumeDetail
                data={{
                  ...procedure?.detail?.rectificationOfGradesDetail,
                  estimatedDate: isComplete
                    ? ''
                    : procedure?.detail?.rectificationOfGradesDetail
                        ?.probableDateOfAttention,
                  responseDate: isComplete
                    ? procedure?.detail?.rectificationOfGradesDetail
                        .responseDate
                    : ''
                }}
                labels={[
                  'Fecha de solicitud',
                  'Fecha de respuesta',
                  'Fecha estimada de respuesta'
                ]}
                fields={['requestDate', 'responseDate', 'estimatedDate']}
              />
              <CardProgress
                image={images}
                title={title}
                subtitle={subtitle}
                comentary={comentary !== null ? comentary : ''}
              >
                {request.status.status === 'PROCEDE' && (
                  <>
                    <b>Nota nueva: </b>{' '}
                    {procedure?.detail?.rectificationOfGradesDetail?.newGrade}
                  </>
                )}
              </CardProgress>
            </div>
          </Step>
        </Block>
      </SubContainer>
    </ContainerProcedure>
  );
};

export default RectificationProgressView;
